import {configureStore} from "@reduxjs/toolkit";
import utilityReducer from "./utility-slice"
import menuReducer from "./menu-slice"
import authReducer from "./auth-slice"
import listReducer from "./list-slice";
import tagReducer from "./tag-slice";
import productReducer from "./product-slice";
import restaurantReducer from "./restaurant-slice";
import branchReducer from "./branch-slice";
import userReducer from "./user-slice";
import employeeReducer from "./employee-slice"
import cartReducer from './cart-slice';
import orderReducer from './order-slice';
import globalSubscriptionReducer from './branch-subscription-slice'
import viewOrderFilterReducer from "./view-order-filter-slice";
import customerReducer from "./customer-slice";
import discountReducer from "./customer-discount-slice"
import vendorReducer from "./vendor-slice";
import purchaseReducer from './purchase-slice'
import internalOrder from './order-internal-slice'
import transactionTypeReducer from './transaction-type-slice'
import transactionReducer from './transaction-slice'
import financialReportReducer from './financial-report-slice'
import incomeProductReducer from './income-product-slice'
import expenseProductReducer from './expense-product-slice'
import recurringExpenseReducer from './recurring-expense-slice'
import importExportReducer from './import-export-slice'
import manualPdfReducer from './manual-pdf-slice'
import settingReducer from './setting-slice'
import bankSettingReducer from './bank-setting-slice'
import contactReducer from './contact-slice'
import buildingReducer from './building-slice'

const store = configureStore({
    // other store configuration options...
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
    reducer: {
        utility: utilityReducer,
        menu: menuReducer,
        auth: authReducer,
        list: listReducer,
        tag: tagReducer,
        product: productReducer,
        restaurant: restaurantReducer,
        branch: branchReducer,
        user: userReducer,
        employee: employeeReducer,
        customer: customerReducer,
        cart: cartReducer,
        order: orderReducer,
        globalSubscription: globalSubscriptionReducer,
        viewOrderFilter: viewOrderFilterReducer,
        discount: discountReducer,
        vendor: vendorReducer,
        purchase: purchaseReducer,
        internalOrder: internalOrder,
        transactionType: transactionTypeReducer,
        transaction: transactionReducer,
        financial: financialReportReducer,
        incomeProduct: incomeProductReducer,
        expenseProduct: expenseProductReducer,
        recurringExpense: recurringExpenseReducer,
        importExport: importExportReducer,
        manualPdf: manualPdfReducer,
        setting: settingReducer,
        bankSetting: bankSettingReducer,
        contact: contactReducer,
        building: buildingReducer
    },
    devTools: process.env.NODE_ENV !== 'production',
});

export default store;
